import { render, staticRenderFns } from "./DownloadItem.vue?vue&type=template&id=047b6e70&scoped=true&"
import script from "./DownloadItem.vue?vue&type=script&lang=js&"
export * from "./DownloadItem.vue?vue&type=script&lang=js&"
import style0 from "./DownloadItem.vue?vue&type=style&index=0&id=047b6e70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047b6e70",
  null
  
)

export default component.exports